export default __webpack_public_path__ + "static/blog-meetup-decb9bfa383a1d6d75c8a3f40c95b196.jpeg";